import { defineStore } from 'pinia';
import { collection, onSnapshot } from 'firebase/firestore';
import { firestore } from '@/firebase';

export const useAvailableSlotsStore = defineStore('availableSlots', {
  state: () => ({
    slotsByDate: {},
    unsubs: [],
    loading: false,
    error: ''
  }),
  persist: { paths: ['slotsByDate'] },
  getters: {
    /** Raw document per dateKey: { userSlots: { [userId]: { slots, serviceIds } } } or legacy { slots }. */
    docForDate: (state) => (dateKey) => {
      return state.slotsByDate[dateKey] || null;
    },
    /** Per-user slots for a date (new shape). Returns {} if legacy or missing. */
    userSlotsForDate: (state) => (dateKey) => {
      const doc = state.slotsByDate[dateKey];
      if (doc && doc.userSlots && typeof doc.userSlots === 'object') return doc.userSlots;
      return {};
    }
  },
  actions: {
    clearUnsubs() {
      for (const unsub of this.unsubs) {
        if (typeof unsub === 'function') unsub();
      }
      this.unsubs = [];
    },
    registerSnapshot() {
      this.clearUnsubs();
      this.loading = true;
      this.error = '';
      const snapshotQuery = collection(firestore, 'availableSlots');
      const unsub = onSnapshot(
        snapshotQuery,
        (snapshot) => {
          this.loading = false;
          this.error = '';
          const next = {};
          snapshot.docs.forEach((docSnap) => {
            next[docSnap.id] = docSnap.data();
          });
          this.slotsByDate = next;
        },
        (err) => {
          this.loading = false;
          this.error = 'Não foi possível carregar os horários.';
          console.warn('availableSlots onSnapshot error', err);
        }
      );
      this.unsubs.push(unsub);
    }
  }
});
